import CardOnFile from '@liveauctioneers/caterwaul-components/lib/CardOnFile/CardOnFile';
import Radio from '@liveauctioneers/caterwaul-components/lib/Radio/Radio';
import { CreditCard } from '@liveauctioneers/caterwaul-components/lib/types/CreditCard';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { usePrevious } from '@/hooks/usePrevious';

type Props = {
    creditCards: CreditCard[];
    deleteCard?: (cardId: number) => void;
    selectCard: (creditCard: CreditCard) => void;
};

const PaymentMethodSelection = ({ creditCards, deleteCard, selectCard }: Props) => {
    const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState<string>();
    const previousNumberOfCards = usePrevious(creditCards?.length);

    useEffect(() => {
        if (Boolean(creditCards) && (!selectedPaymentMethodId || previousNumberOfCards !== creditCards?.length)) {
            const defaultCardOnFile = creditCards.find((cof) => cof.defaultCard);
            setSelectedPaymentMethodId(`card-${defaultCardOnFile?.id}`);
            //just to make sure the parent is on the same page.
            if (defaultCardOnFile && selectCard) {
                selectCard(defaultCardOnFile);
            }
        }
    }, [creditCards, previousNumberOfCards, selectCard, selectedPaymentMethodId]);

    const creditCardRadios = useMemo(() => {
        if (!creditCards) {
            return null;
        }
        const sortedcreditCards = creditCards.sort((cardA, cardB) => {
            return new Date(cardB.created).getTime() - new Date(cardA.created).getTime();
        });
        return sortedcreditCards.map((creditCard) => {
            const radioId = `card-${creditCard.id}`;
            const selected = selectedPaymentMethodId === radioId;
            return (
                <StyledRadio
                    id={radioId}
                    key={creditCard.id}
                    label={
                        <div>
                            <CardOnFile
                                creditCard={creditCard}
                                deleteCard={
                                    deleteCard
                                        ? (event) => {
                                              event.stopPropagation();
                                              if (selected) {
                                                  setSelectedPaymentMethodId(undefined);
                                              }
                                              deleteCard(creditCard.id);
                                          }
                                        : undefined
                                }
                                deleteCardLinkText="Remove"
                                isDefault={creditCard.defaultCard}
                                isRadio
                            />
                        </div>
                    }
                    onClick={(event) => {
                        const id = event.currentTarget.id;
                        setSelectedPaymentMethodId(id);
                        selectCard(creditCard);
                    }}
                    selectedName={selectedPaymentMethodId}
                />
            );
        });
    }, [creditCards, selectedPaymentMethodId, deleteCard, selectCard]);

    return (
        <div>
            {/* Not using Radios component here so we can fully control it ourselves. */}
            {creditCardRadios}
        </div>
    );
};

export default PaymentMethodSelection;

const StyledRadio = styled(Radio).attrs(() => ({
    radioCircleClassName: 'radioCircleClassName',
}))`
    width: 100%;
    padding: 10px 0 0 25px;

    .radioCircleClassName {
        top: 36px;
        left: 0;
    }
`;
